import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import { Flex, Box } from 'rebass'
import MenuIcon from 'mdi-react/MenuIcon'
import NavLink from './NavLink'

const styles = {
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  button: {
    padding: 0,
    minWidth: '50px',
  }
};

class NavDrawer extends React.Component {
  state = {
    right: false,
  };

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };

  render() {
    const { classes } = this.props;

    const sideList = (
      <div className={classes.list}>
          <Flex flexDirection='column' mt={3} ml={2} >
              <Box p={2}><NavLink to="#" children="Home" /></Box>
              <Box p={2}><NavLink to="#about" children="About" /></Box>
              <Box p={2}><NavLink to="#team" children="Team" /></Box>
              <Box p={2}><NavLink to="#values" children="Values" /></Box>
              <Box p={2}><NavLink to="#services" children="Services" /></Box>
              <Box p={2}><NavLink to="#articles" children="Articles" /></Box>
              <Box p={2}><NavLink to="#contact" children="Contact" /></Box>
          </Flex>
      </div>
    );

    return (
      <div>
        <Button onClick={this.toggleDrawer('right', true)} className={classes.button}>
          <MenuIcon color='#000' />
        </Button>
        <Drawer anchor="right" open={this.state.right} onClose={this.toggleDrawer('right', false)}>
          <div
            tabIndex={0}
            role="button"
            onClick={this.toggleDrawer('right', false)}
            onKeyDown={this.toggleDrawer('right', false)}
          >
            {sideList}
          </div>
        </Drawer>
      </div>
    );
  }
}

NavDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NavDrawer) ;



// WEBPACK FOOTER //
// ./src/elements/Navbar/NavDrawer.js